import { useQuery } from 'react-query';
import { getQueryKeys } from './queryKeys';
import getFlatMeterAttachment from '../requests/getFlatMeterAttachment';

const useFlatMeterAttachment = (data, options = {}) =>
  useQuery(
    getQueryKeys.flatMeterAttachment(data),
    () => getFlatMeterAttachment(data.meterId, data.fileName),
    options
  );

export default useFlatMeterAttachment;
